import { FC, ReactNode } from 'react'
import classnames from 'classnames'

type HintProps = {
  hint?: string
  position?: 'top' | 'bottom' | 'left' | 'right'
  size?: 'small' | 'medium' | 'large'
  children?: ReactNode
}

const Hint: FC<HintProps> = ({ hint = '', position = 'top', size = 'medium', children }) => {
  const getContent = (): ReactNode => {
    if (children) {
      return children
    } else {
      return <span className="hint-icon">&#9432;</span>
    }
  }

  const className = classnames('hint', `hint--${size}`, `hint--${position}`, 'hint--timetoast')

  const content = getContent()

  return (
    <span className={className} data-hint={hint}>
      {content}
    </span>
  )
}

export default Hint
